import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { class: "px-5 mt-3 pb-3 filter-card " + (_vm.dense ? "pt-8" : "pt-5") },
    [
      _c(
        VForm,
        [
          _vm._l(_vm.value, function (row, i) {
            return _c(
              VRow,
              { key: i },
              [
                _vm._l(row, function (col, j) {
                  return [
                    _vm.appAllowAccess(
                      col.authenticated ? col.authenticated : false,
                      col.roles ? col.roles : [],
                      col.permissions ? col.permissions : []
                    )
                      ? _c(
                          "div",
                          { key: j, class: col.column + " py-1" },
                          [
                            col.component != "slot"
                              ? _c(
                                  col.component,
                                  _vm._b(
                                    {
                                      tag: "component",
                                      attrs: { dense: _vm.dense },
                                      on: { keyup: _vm.nextInput },
                                      model: {
                                        value: col.vModel,
                                        callback: function ($$v) {
                                          _vm.$set(col, "vModel", $$v)
                                        },
                                        expression: "col.vModel",
                                      },
                                    },
                                    "component",
                                    col.props,
                                    false
                                  )
                                )
                              : _vm._t(
                                  col.props.name,
                                  null,
                                  { dense: _vm.dense },
                                  col.props
                                ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("input", { staticClass: "hide", on: { focus: _vm.searchData } }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        VRow,
        { staticClass: "my-1 mr-2" },
        [
          _vm.search
            ? _c(
                VBtn,
                {
                  staticClass: "ml-auto white--text",
                  attrs: { color: "orange" },
                  on: { click: _vm.clearFilter },
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("common.clear")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reset
            ? _c(
                VBtn,
                {
                  staticClass: "ml-3 white--text",
                  attrs: { color: "pink" },
                  on: { click: _vm.resetFilter },
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("common.reset")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.clear
            ? _c(
                VBtn,
                {
                  staticClass: "ml-3",
                  attrs: { color: "primary" },
                  on: { click: _vm.searchData },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.search")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }